import React, { Component } from 'react';
import { curveMonotoneX, line } from 'd3-shape';

import PropTypes from 'prop-types';
import { select } from 'd3-selection';

class LineChart extends Component{
    componentDidMount(){
        this.renderLine();
    }

    componentDidUpdate(){
        this.renderLine();
    }

    renderLine = () => {
        const { data, xScale, yScale, keys: { x, y } } = this.props;

        const lineGraph = line()
            .x( d => xScale()( d[x] ) )
            .y( d => yScale()( d[y] ) )
            .curve( curveMonotoneX );

        // draw the line
        select( this.line )
            .append( 'path' )
            .datum( data )
            .attr( 'd', lineGraph );
    }

    render(){
        const { styles } = this.props;

        return (
            <g className={styles.linepath} ref={el => this.line = el}></g>
        );
    }
}


LineChart.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape( {
            count: PropTypes.number,
            date: PropTypes.instanceOf( Date ),
        } ),
    ),
    keys: PropTypes.shape( {
        x: PropTypes.string,
        y: PropTypes.string,
    } ),
    styles: PropTypes.object,
    xScale: PropTypes.func.isRequired,
    yScale: PropTypes.func.isRequired,
};

export default LineChart;
